


























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class ComponentView extends Vue {
  public items: Common.Component[] = new Array(0);
  public params: Common.ComponentQuery = new Common.ComponentQuery();
  public importQuery = new Common.ImportQuery('構成品', 'Component');
  public exportQuery = new Common.ExportQuery('構成品', this.params);
  public tenantSettings: Common.TenantSettings = null;
  public visibleTypes = Common.visibleTypes;  

  @Prop() public auditNo:string;
  @Prop() public assemblyId:number;
  @Prop() public assembly:Common.Assembly;  
  @Prop({default:null}) public popup: Components.PopupEditor;  

  public inputType:Common.InputTypes = Common.InputTypes.Order;
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'assembly', text:'セット品' },
    { value: 'componentCommodity', text:'構成品商品' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];

  //一覧項目可変プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public listGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([], 0, 'grid');

  public created() {
    this.tenantSettings = this.$api.tenantSettings;

    // 予備項目表示の可変対応
    this.listGridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 100),
      new Common.GridItemConfiguration('ワークフロー', 180),      
      new Common.GridItemConfiguration('ID', 100),
      new Common.GridItemConfiguration('セット品', 150),
      // new Common.GridItemConfiguration('構成品商品コード', 150),      
      new Common.GridItemConfiguration('構成品商品', 150),
      new Common.GridItemConfiguration('構成品SKU', 150),
      new Common.GridItemConfiguration('構成数量', 150),
      // new Common.GridItemConfiguration('分解基準単価', 180),
    );
    this.listGridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,true,false,false));
    this.listGridConfig.setGridItems(
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),      
    );        
    this.listCaptions =this.listGridConfig.gridCaptions;
    this.listWidths = this.listGridConfig.gridWidths;
    this.listSlots = this.listGridConfig.gridSlots;

    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }

    if (this.assemblyId){
      this.params.assemblyId = this.assemblyId;
    } else if (this.assembly)    {
      this.params.assembly = this.assembly;
    }
    if(!this.auditNo && !this.assemblyId){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
  }
  
  public async onCreate(obj: Common.Component) {
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    if (this.popup && this.assembly)obj.assembly = this.assembly;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.Component):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }

  public isEditable(item: Common.Component):boolean {
    return item.state == Common.MasterBaseStatus.NotPosted;
  }

  public onLinkClicked(item: Common.Assembly){
      this.$router.push(String.format('/master/Assembly?id={0}', item.id));         
  }
  
}
